import {
  Box,
  Typography,
  Link,
  IconButton,
  Container,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box sx={{ backgroundColor: "#800020", color: "white", py: 2 }}>
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "center",
            gap: isMobile ? 2 : 0,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isMobile ? "center" : "flex-start",
              width: isMobile ? "100%" : "auto",
            }}
          >
            <img
              src="/images/Logo_white.png"
              alt="Pelerinul Creștin"
              style={{ width: "55px", marginRight: "5px" }}
            />
            <Typography
              variant="subtitle2"
              sx={{
                fontFamily: "Libre Baskerville",
                fontWeight: 700,
                fontSize: isMobile ? "0.8rem" : "inherit",
              }}
            >
              Agentia Pelerinul Creștin
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: "center",
              gap: isMobile ? 1 : 2,
              width: isMobile ? "100%" : "auto",
              textAlign: "center",
            }}
          >
            <Link
              href="/termeni-si-conditii"
              underline="hover"
              color="inherit"
              sx={{
                fontFamily: "Inter",
                fontSize: "14px",
                textDecoration: "underline",
                fontWeight: 500,
              }}
            >
              Termeni și Condiții
            </Link>
            <IconButton
              href="https://www.facebook.com/p/Agen%C8%9Bia-Pelerinul-Cre%C8%99tin-100053946706916/"
              target="_blank"
              color="inherit"
              sx={{ padding: isMobile ? 0.5 : "default" }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={isMobile ? "20" : "25"}
                height={isMobile ? "20" : "25"}
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M16 3C13.4288 3 10.9154 3.76244 8.77759 5.1909C6.63975 6.61935 4.97351 8.64968 3.98957 11.0251C3.00563 13.4006 2.74819 16.0144 3.2498 18.5362C3.75141 21.0579 4.98953 23.3743 6.80762 25.1924C8.6257 27.0105 10.9421 28.2486 13.4638 28.7502C15.9856 29.2518 18.5995 28.9944 20.9749 28.0104C23.3503 27.0265 25.3807 25.3603 26.8091 23.2224C28.2376 21.0846 29 18.5712 29 16C28.9964 12.5533 27.6256 9.24882 25.1884 6.81163C22.7512 4.37445 19.4467 3.00364 16 3ZM17 26.9538V19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18C21 17.7348 20.8946 17.4804 20.7071 17.2929C20.5196 17.1054 20.2652 17 20 17H17V14C17 13.4696 17.2107 12.9609 17.5858 12.5858C17.9609 12.2107 18.4696 12 19 12H21C21.2652 12 21.5196 11.8946 21.7071 11.7071C21.8946 11.5196 22 11.2652 22 11C22 10.7348 21.8946 10.4804 21.7071 10.2929C21.5196 10.1054 21.2652 10 21 10H19C17.9391 10 16.9217 10.4214 16.1716 11.1716C15.4214 11.9217 15 12.9391 15 14V17H12C11.7348 17 11.4804 17.1054 11.2929 17.2929C11.1054 17.4804 11 17.7348 11 18C11 18.2652 11.1054 18.5196 11.2929 18.7071C11.4804 18.8946 11.7348 19 12 19H15V26.9538C12.181 26.6964 9.56971 25.3622 7.7093 23.2287C5.8489 21.0952 4.8826 18.3266 5.0114 15.4988C5.1402 12.671 6.35419 10.0017 8.40085 8.04613C10.4475 6.09057 13.1693 4.9993 16 4.9993C18.8307 4.9993 21.5525 6.09057 23.5992 8.04613C25.6458 10.0017 26.8598 12.671 26.9886 15.4988C27.1174 18.3266 26.1511 21.0952 24.2907 23.2287C22.4303 25.3622 19.819 26.6964 17 26.9538Z"
                  fill="#fff"
                />
              </svg>
            </IconButton>
            {/* <Typography
              variant="body2"
              color="inherit"
              sx={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "14px",
              }}
            >
              Telefon: +40 755 182 802
            </Typography> */}
            <a
              href="tel:+40755182802"
              style={{
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "14px",
                color: "white",
                textDecoration: "none",
              }}
            >
              Telefon: +40 755 182 802
            </a>
          </Box>
        </Box>
      </Container>
      <Box
        sx={{
          borderTop: "1px solid rgba(255,255,255,0.1)",
          mt: 2,
          pt: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontFamily: "Inter",
            fontSize: isMobile ? "0.7rem" : "0.75rem",
          }}
        >
          © 2026 Agentia Pelerinul Creștin. Toate drepturile rezervate.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
